import $windowConfig from '../WindowConfig.js'
import { axiosP, axiosG, Api } from './index.js'

export default {
  /**
   * 1.1 一键登录(新版)
   * * [rap](https://rap.eoms.phone580.com/workspace/myWorkspace.do?projectId=28#221)
   * * 描述: 蜂助手一键注册登录，它似乎支持很多种登录，所以你务必要打开 rap 看看
   * * 负责人：成志玮
   * * loginType: 登录类型;1,手机号+验证码;2,移动登录;3,微信公众号登录;4,微信小程序登录
   * * 成功返回 resp.[success=true, valueObject: {authToken, userInfo: {user: {staffCode/fOperUserId}}}]
   * * 失败返回 resp.[success=false, code, message ]
   * @param data {object} {mobile/smsCode/loginType:1}
   * @returns {Promise<*>}
   */
  authLoginV2 (data = {}) {
    const {
      clientId,
      channelId,
      modelId,
      templateId
    } = $windowConfig

    const {
      smsCode,
      mobile,
      loginType = 1
    } = data

    return axiosP(Api.www + 'fzsuserapi/api/user/authloginv2', {
      clientVersionId: clientId,
      registerFrom: channelId,
      channelId,
      // 拓展信息
      extendInfo: {
        extendType: 'SMS',
        // 短信组件id
        modelid: modelId,
        // 短信模板id
        templateid: templateId,
        smsValiCode: smsCode
      },
      mobile,
      // 登录类型;1,手机号+验证码;2,移动登录;3,微信公众号登录;4,微信小程序登录
      loginType
    })
  },

  /**
   * 3.0.下发短信验证码
   * * [rap](https://rap.eoms.phone580.com/workspace/myWorkspace.do?projectId=28#407)
   * * 描述: 用以普通登录，一般来讲，很常用，没有特殊情况可用这个
   * * 负责人：成志玮
   * * **返回**： resp[success:true|false, code: '0|...' ]
   * * 0：短信发送成功: 1：操作频繁; 2：图形验证码错误:9：需验证码;  10：非法用户; 除了0，其它都是失败，失败原因直接获取返回的message信息
   * * 一般除了 '0'，其他按 '9' 验证码处理
   * * 该接口前三次(默认)发送短信不用传验证码，若modelid与templateid不传，则使用默认配置。
   * @param data {object} {mobile, validCode:图形验证码(可为空), key:图形验证码key(可为空)}
   * @returns {Promise<*>}
   */
  sendSmsCode (data = {}) {
    const {
      modelId = '9',
      templateId = '14'
    } = $windowConfig

    const {
      mobile: phonenum,
      validCode,
      key
    } = data

    const param = {
      modelid: modelId,
      templateid: templateId,
      phonenum,
      validCode,
      key
    }

    return axiosG(Api.www + 'fzsuserapi/user/sendsmscode', param)
  },

  /**
   * * 描述: 在上面的 sendSmsCode 有提示需要图形验证码时，使用此接口进行图形验证码
   * * 负责人：未知
   * @param random 随机数，亦为 key
   * @returns {string} 图形验证码的图片
   */
  getCaptcha (random = '') {
    return Api.www + 'fzscaptchaapi/captcah/captcah.jpg?key=' + random
  },

  /**
   * 3.8 第三方渠道登录接口（新接入不再使用）用户中心
   * * [rap](https://rap.eoms.phone580.com/workspace/myWorkspace.do?projectId=28#813)
   * * 描述，这个接口有很多个版本，注意甄别，目前提供的功能有：
   * * 1 提供给中行app获取到 cipherText 并用来做第三方登录(fzs)
   * * 2 没有了，对接其他 登录功能，要看别人的代码
   * * 负责人：未知
   * * 成功返回：
   * * resp.success: true
   * * const { authToken, userInfo, exjf, bocUser } = resp.valueObject
   * * const phoneNum = userInfo.user.mobile || userInfo.user.bindMobile
   * * const _userInfo = {
   *     token: authToken, authToken: authToken, userId: exjf.userId,
   *     phoneNum, phone: phoneNum, bocUserCityCode: bocUser.cityCode,
   *     userRole: bocUser.userRole
   *  }
   *  * 失败返回
   *  * resp.success: false, resp.code = '400004' 用户首次绑定手机号码, message
   * @param data {object} {phone/smsCode/cipherText: 第三方加密串、或为第三方token, 其中 phone/smsCode可空，当返回 code === '400004' 则需要绑定手机号，就需要传}
   * @return {*|Promise<any>}
   */
  authLoginThirdUser (data = {}) {
    const { channelId, clientId, modelId = '9', templateId = '14' } = $windowConfig
    const { phone = '', cipherText, smsCode = '' } = data

    const param = {
      channelId,
      clientVersionId: clientId,
      registerFrom: channelId,
      thirdToken: cipherText,
      uid: phone,
    }

    if (smsCode) {
      param.extendInfo = JSON.stringify({
        extendType: 'SMS',      // SMS
        modelid: modelId,          // 短信组件id
        templateid: templateId,    // 短信模板id
        smsValiCode: '' + smsCode, // 短信验证码
        loginType: '1'             // 登录类型;1,手机号+验证码; 8、邀请码注册
      })
    } else {
      param.loginType = '10'
      param.extendInfo = JSON.stringify({
        loginMethod: '',
        extendType: '',
      })
    }

    return axiosP(Api.www + 'fzsuserapi/api/user/authlogin-third-user', param)
  },
}
